import { getOptionsFromObject } from '../utils/objects';
import { FuelType } from './../types/asset';
export const ASSET_TYPE_VEHICLE = 'vehicle';
export const ASSET_TYPE_CONTAINER = 'container';
export const ASSET_TYPE_PHONE = 'phone';

export const ASSET_TYPE = {
  [ASSET_TYPE_VEHICLE]: 'vehículo',
  [ASSET_TYPE_CONTAINER]: 'contenedor',
  [ASSET_TYPE_PHONE]: 'celular',
};

export const FUEL_TYPE_LABEL = {
  [FuelType.magna]: 'Gasolina Regular (Magna)',
  [FuelType.premium]: 'Gasolina Premium',
  [FuelType.diesel]: 'Diésel',
  [FuelType.lpGas]: 'Gas Licuado de Petróleo (GLP)',
  [FuelType.cnv]: 'Gas Natural Vehicular (GNV)',
  [FuelType.electric]: 'Electricidad',
  [FuelType.hydrogen]: 'Hidrógeno',
};

export const FUEL_TYPE_OPTIONS = getOptionsFromObject(FUEL_TYPE_LABEL);
